<div
  #popoverRef
  popover
  class="ntt-dropdown-menu"
  [style.--ntt-anchor]="anchorName()"
>
  <ng-content />
</div>
